export const WEBSITE_PAGE_URL_PLACEHOLDER = '%WEBSITE_PAGE_URL_ %'

export function getWebsitePageReplacement(pageId: number) {
  return WEBSITE_PAGE_URL_PLACEHOLDER.replace(' ', String(pageId))
}

export function isWebsitePageUrlPlaceholder(placeholder: string) {
  return placeholder === WEBSITE_PAGE_URL_PLACEHOLDER
}
export function isWebsitePageUrlPlaceholderValue(value: string) {
  return isWebsitePageUrlPlaceholder(value.replace(/\d+/g, ' '))
}
